import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.number.constructor";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
import { mapState } from 'vuex';
import { codemirror } from 'vue-codemirror';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import has from 'lodash/has';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { themesMixin } from '@/utils/themes';
import LineChartMixin from '@/components/core/dtwin/lineChartMixin';
import { relativeBreakpoint } from '../../../../utils/vuex';
import ApiService from '../../../../services/apiService';
import { calculateAxisValue } from '../../../../utils/charts';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
var CHART_BEGIN_ZERO = false;
var chartPreviewConfig = {
  legend: {
    display: false
  },
  scales: {
    yAxes: [{
      ticks: _objectSpread(_objectSpread({}, CHART_BEGIN_ZERO ? {
        suggestedMin: 0
      } : {}), {}, {
        fontSize: 8
      }),
      gridLines: {
        display: true
      }
    }],
    xAxes: [{
      type: 'time',
      distribution: 'series',
      time: {
        tooltipFormat: 'YYYY-MM-DD HH:mm',
        unit: 'day',
        displayFormats: {
          day: 'D.M.'
        }
      },
      ticks: {
        autoSkip: true,
        fontSize: 10
      },
      gridLines: {
        display: false
      }
    }]
  }
};
var cmOptionsDefaults = {
  mode: 'application/text',
  tabSize: 4,
  lineNumbers: false,
  line: true,
  lineWrapping: true,
  foldGutter: true,
  styleActiveLine: true,
  styleSelectedText: true,
  readOnly: true,
  hintOptions: {
    completeSingle: false
  },
  viewportMargin: Infinity
};
export default {
  name: 'CoreDtwinStatePreviewDbTiles',
  components: {
    codemirror: codemirror
  },
  mixins: [relativeBreakpoint, LineChartMixin, themesMixin],
  props: {
    twinDataStates: {
      type: Array,
      required: true
    },
    updatedStates: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    favCard: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    noDataAlert: {
      type: Boolean,
      required: false,
      default: false
    },
    tileSizeSetting: {
      type: Number,
      required: false,
      default: 0
    },
    chartDotRadius: {
      type: Number,
      required: false,
      default: 2
    },
    overflow: {
      type: Boolean,
      required: false,
      default: false
    },
    // only together with overflow
    maxHeight: {
      type: Number,
      required: false,
      default: 450
    }
  },
  data: function data() {
    return {
      previewJsonData: null,
      previewStringData: null,
      showJsonDialog: false,
      showStringDialog: false,
      historyState: null,
      showHistoryDialog: false,
      cmOptionsJson: _objectSpread(_objectSpread({}, cmOptionsDefaults), {
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        mode: 'application/ld+json',
        lineWrapping: false
      }),
      cmOptionsString: _objectSpread(_objectSpread({}, cmOptionsDefaults), {
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        mode: 'application/text',
        lineWrapping: true
      }),
      chartDataFormated: {},
      chartLoading: false,
      multiChartConfig: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    colsPerTile: function colsPerTile() {
      if (this.relativeBreakpoint.width > 1100) {
        return 3;
      }

      if (this.relativeBreakpoint.width > 800) {
        return 4;
      }

      if (this.relativeBreakpoint.width > 510) {
        return 6;
      }

      return 12;
    },
    boxStyle: function boxStyle() {
      var result = '';

      if (this.tileSizeSetting) {
        result = "".concat(result, "margin-left: 7px; margin-right: 7px;");
      }

      if (this.overflow) {
        result = "".concat(result, "max-height: ").concat(this.maxHeight, "px; overflow: auto;");
      }

      return result;
    },
    previewVisual: function previewVisual() {
      if (this.tileSizeSetting === 1) {
        return 'preview-tile-visual';
      }

      return 'preview-visual';
    },
    previewBatteryHeight: function previewBatteryHeight() {
      if (this.tileSizeSetting === 1) {
        return 83;
      }

      return 160;
    },
    previewAlertHeight: function previewAlertHeight() {
      if (this.tileSizeSetting === 1) {
        return 70;
      }

      return 140;
    },
    uiComponents: function uiComponents() {
      if (this.favCard && this.tileSizeSetting === 1) {
        return true; // FavCard and Big Tiles
      } else if (this.favCard && this.tileSizeSetting === 0) {
        return false; // FavCard and small Tiles
      } else if (!this.favCard && this.tileSizeSetting === 0) {
        return true; // No FavCard and D-Twin or other view
      }

      return true;
    },
    hasStateEditPermission: function hasStateEditPermission() {
      return (this.permissions || {})['DigitalTwin.manage'] || (this.permissions || {})['DigitalTwin.write'];
    },
    tiles: function tiles() {
      if (!this.twinDataStates) {
        return [];
      }

      var twinDataStates = [].concat(this.twinDataStates);
      twinDataStates.sort(function (a, b) {
        return a.properties.orderIdx - b.properties.orderIdx;
      });
      var sanitizedStates = [];

      for (var i = 0; i < twinDataStates.length; i++) {
        var state = twinDataStates[i];

        if (get(state, 'properties.valueType') === 'boolean') {
          // for each boolean state, add a button to toggle <--- that is the past
          // nowadays we jst show a nice colored icon and no possibility to toggle a button
          var modifierBoolTile = _objectSpread(_objectSpread({}, state), {}, {
            type: 'modifier-bool'
          });

          twinDataStates[i] = modifierBoolTile;
        } // Delete Geo-Coordnates if linked to DTWin Position or if visualisation-type is "hidden"


        if (!state.properties.linkGeoCoordinate && this.getComponentType(twinDataStates[i]) !== 'hidden') {
          if (!twinDataStates[i].properties.visual) {
            twinDataStates[i].properties.visual = {};
          }

          if (!twinDataStates[i].properties.visual.options) {
            twinDataStates[i].properties.visual.options = {};
          }

          if (twinDataStates[i].value === undefined) {
            twinDataStates[i].value = {};
          }

          sanitizedStates.push(twinDataStates[i]);
        }
      }

      return sanitizedStates;
    }
  }),
  watch: {
    updatedStates: function updatedStates() {
      var _this = this;

      if (this.historyState && this.updatedStates.findIndex(function (s) {
        return s.id === _this.historyState.id;
      }) >= 0) {
        if (this.$refs['dtwin-state-history']) {
          this.$refs['dtwin-state-history'].reloadData();
          this.filteredDashboardData(this.twinDataStates);
        }
      }
    },
    twinDataStates: function twinDataStates(updated, old) {
      if (!isEqual(updated, old)) {
        this.fetchChartData();
      }
    }
  },
  created: function () {
    var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.fetchChartData();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    get: get,
    calculateAxisValue: calculateAxisValue,
    fetchChartData: function fetchChartData() {
      var _this2 = this;

      if (!this.twinDataStates) {
        return;
      }

      this.chartLoading = true;
      var promises = this.filteredDashboardData(this.twinDataStates).map(function (item) {
        _this2.setMultiConfigStateData(item); // MWa Debug console.log(item);


        return _this2.loadChartData(item);
      });
      return Promise.all(promises).then(function (results) {
        return results.map(function (item) {
          _this2.chartDataFormated[item.objModel.id] = _this2.formatMultipleData(item.objModel, item.responseData); // force-redraw the whole linechart component

          item.objModel.lineChartId = new Date().toISOString();
          return _this2.chartDataFormated[item.objModel.id];
        });
      }).then(function (data) {
        _this2.chartLoading = false;
        return data;
      }).catch(function (err) {
        return console.error(err);
      });
    },
    getCompStyle: function getCompStyle(twinDataState) {
      if (this.getComponentType(twinDataState) === 'lineChart') {
        // IF tileSizeSetting is 1 then never show line charts with a span greater than 3
        if (this.tileSizeSetting === 1) {
          return {
            gridColumn: 'span 3'
          };
        }

        if (this.$vuetify.breakpoint.lgAndUp) {
          return {
            gridColumn: "span ".concat(this.getSpan(twinDataState))
          };
        }

        return {
          gridColumn: 'span 2'
        };
      }

      return {};
    },
    getComponentType: function getComponentType(state) {
      if (!state) {
        return null;
      }

      var typeState = get(state, 'properties.valueType');

      var typeReal = _typeof(get(state, 'value.value'));

      var typeVisual = get(state, 'properties.visual.type'); // if a visual type was set via visual config then use that one

      if (typeVisual) {
        return typeVisual;
      }

      if (state.type === 'modifier-bool') {
        return 'modifier-bool';
      }

      if (typeState === 'button') {
        return 'button';
      } // if a the states type is json and real type is string or object than use json


      if (typeState === 'json' && (typeReal === 'string' || typeReal === 'object')) {
        return 'json';
      } // otherwise return based on the real type of the value or the states type
      // 'odometer' for numbers and 'string' to display everything else


      switch (typeReal || typeState) {
        case 'number':
          return 'fittext';

        default:
          return 'string';
      }
    },
    getSpan: function getSpan(state) {
      return Math.min(get(state, 'properties.visual.options.span'), 5) || 2;
    },
    getLowerBound: function getLowerBound(state, defaultValue) {
      if (state.properties.lowerBound === undefined) {
        return defaultValue;
      }

      return parseFloat(state.properties.lowerBound);
    },
    getUpperBound: function getUpperBound(state, defaultValue) {
      if (state.properties.upperBound === undefined) {
        return defaultValue;
      }

      return parseFloat(state.properties.upperBound);
    },
    getThresholds: function getThresholds(state, defaultMin, defaultMax) {
      var min = this.getLowerBound(state, defaultMin);
      var max = this.getUpperBound(state, defaultMax);
      return [min + (max - min) * 0.1, max - (max - min) * 0.5];
    },
    modifierBoolButtonColor: function modifierBoolButtonColor(boolSwitchData) {
      if (get(boolSwitchData, 'value.value') === true) {
        return this.color;
      }

      return undefined;
    },
    showJSON: function showJSON(a) {
      this.previewJsonData = this.outputValue(a);
      this.showJsonDialog = true;
    },
    showString: function showString(s) {
      this.previewStringData = String(s).trim();
      this.showStringDialog = true;
    },
    showHistory: function showHistory(a) {
      this.historyState = a;
      this.showHistoryDialog = true;
    },
    outputValue: function outputValue(item) {
      if (item === null) {
        return 'null';
      }

      try {
        var jsonObject = _typeof(item) === 'object' ? item : JSON.parse(item); // parse and then stringify again to get a nice format

        return JSON.stringify(jsonObject, null, 1);
      } catch (error) {// on error we return outside of try/catch
      }

      return item;
    },
    localizeDate: function localizeDate(a) {
      if (a) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);

        if (this.tileSizeSetting === 0) {
          return moment(a).format('L LTS');
        }

        return moment(a).format('L');
      }

      return '-';
    },
    setMultiConfigStateData: function setMultiConfigStateData(objModel) {
      if (!isEmpty(objModel.properties.visual.options)) {
        var chartLinesCurved = has(objModel.properties.visual.options, 'chartLinesCurved') ? objModel.properties.visual.options.chartLinesCurved : true;
        var chartOmitNull = has(objModel.properties.visual.options, 'chartOmitNull') ? objModel.properties.visual.options.chartOmitNull : true;
        var start = moment(get(objModel, 'properties.visual.options.queryStartDate'));
        var end = moment(get(objModel, 'properties.visual.options.queryEndDate')); // We have to check whether to display days or hours in the xAxis ticks

        var differenceInDays = end.diff(start, 'days');
        var chartPreviewConfigVar = cloneDeep(chartPreviewConfig); // Display hours if we have a day or less

        if (differenceInDays <= 1) {
          chartPreviewConfigVar.scales.xAxes[0].time.unit = 'hour';
          chartPreviewConfigVar.scales.xAxes[0].displayFormats = {};
        }

        this.multiChartConfig[objModel.id] = _objectSpread(_objectSpread({}, chartLinesCurved ? _objectSpread(_objectSpread({}, chartPreviewConfigVar), {}, {
          elements: {
            line: {
              tension: 0.5
            },
            point: {
              pointStyle: 'circle',
              radius: this.chartDotRadius
            }
          }
        }) : _objectSpread(_objectSpread({}, chartPreviewConfigVar), {}, {
          elements: {
            line: {
              tension: 0
            }
          }
        })), chartOmitNull ? {} : {
          spanGaps: true
        });
      }
    },
    faIcon: function faIcon(dtItem) {
      return get(dtItem, 'value.value') ? get(dtItem, 'properties.visual.options.boolVisual.firstFaIcon') : get(dtItem, 'properties.visual.options.boolVisual.secondFaIcon');
    },
    faIconColor: function faIconColor(dtItem) {
      return get(dtItem, 'value.value') ? get(dtItem, 'properties.visual.options.boolVisual.firstColor') : get(dtItem, 'properties.visual.options.boolVisual.secondColor');
    },
    stateTitle: function stateTitle(dtItem) {
      return get(dtItem, 'value.value') ? get(dtItem, 'properties.visual.options.boolVisual.firstStateTitle') : get(dtItem, 'properties.visual.options.boolVisual.secondStateTitle');
    },
    isBooleanVisualisation: function isBooleanVisualisation(state) {
      return get(state, 'properties.valueType') === 'boolean' && !get(state, 'properties.visual.options.type') && get(state, 'properties.visual.options.boolVisual') !== undefined && get(state, 'properties.visual.options.boolVisual.firstStateTitle') !== '' && get(state, 'properties.visual.options.boolVisual.firstFaIcon') !== '' || get(state, 'properties.visual.options.boolVisual.secondStateTitle') !== '' && get(state, 'properties.visual.options.boolVisual.secondFaIcon') !== '';
    },
    modifierBoolButtonIcon: function modifierBoolButtonIcon(boolSwitchData) {
      if (get(boolSwitchData, 'value.value') === true || get(boolSwitchData, 'value.value') === 1) {
        return 'fal fa-toggle-on';
      }

      return 'fal fa-toggle-off';
    },
    modifierBoolButtonClicked: function modifierBoolButtonClicked(boolSwitchData) {
      boolSwitchData.value.value = !boolSwitchData.value.value;
      ApiService.digitalTwinUpdateStateValue(this, {
        id: boolSwitchData.id,
        dtwinId: boolSwitchData.dtwinId,
        value: get(boolSwitchData, 'value.value'),
        skipTransformer: true
      }).then(function () {// this.$emit('didUpdateStates', [boolSwitchData.id]);
      }).catch(function (error) {
        console.error(error);
      });
    }
  }
};